<template>
    <div>
        <AnimalsTable />
    </div>
</template>

<script>
import AnimalsTable from '@/components/animal/AnimalsTable.vue'
export default {
    components: {
        AnimalsTable
    },
    name: 'Animals'
}
</script>